<template>
  <div class="flex w-full">
    <div
      v-for="(option, index) in options"
      :key="index"
      class="text-lg px-4 cursor-pointer flex-no-shrink"
      :class="{
        'pl-0': index === 0,
        'border-r': options.length - 1 > index
      }"
      @click="$emit('input', option)"
    >
    <span
        class="border-b-2 pb-2"
        :class="[
          value === option ? 'border-secondary font-bold' : 'border-transparent'
        ]"
    >
      {{ option }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: ['value', 'options']
}
</script>
